import React from 'react';
import { IconHotel } from '@americanexpress/dls-icons';
import clsx from 'clsx';
import styles from './AbandonHotel.scss';

const AbandonHotelIcon = () => (
  <div
    data-testid="abandon-hotel-icon"
    className={clsx('margin-2-r dls-white-bg', styles.iconContainer)}
  >
    <IconHotel
      reactlytics={{
        disable: true,
      }}
      id="hotelIcon"
      color="brand"
      className={styles.iconSize}
      size="md"
    />
  </div>
);

export default AbandonHotelIcon;
